import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { QueueColumnHeaders } from './queue-column-headers';
import { useQueueStore } from '../context/use-queue-store';
import { Grid, Box } from '@cad-arc';
import { ColumnDefinitionEnumType } from '@mark43/cad-api';

export const QUEUE_ROW_UPDATE_BOX_WIDTH_PX = 18;

export const QueueHeaderRow = observer(function QueueHeaderRow({
    children,
}: React.PropsWithChildren<Record<never, never>>): React.ReactElement {
    const store = useQueueStore();

    const handleResize = useCallback(
        (width: string, columnDefinitionName: ColumnDefinitionEnumType) => {
            store.workspacePanel.queue.setColumnWidth(columnDefinitionName, parseInt(width, 10));
        },
        [store]
    );
    const handleSort = useCallback(
        (definition: ColumnDefinitionEnumType) => {
            store.setSort(definition);
        },
        [store]
    );

    const handleReorder = useCallback(
        (columnDefinitionName: ColumnDefinitionEnumType, newIndex: number) => {
            store.workspacePanel.queue.setColumnOrder(columnDefinitionName, newIndex);
        },
        [store]
    );

    return (
        <Box
            style={{
                '--columns': store.workspacePanel.queue.queueColumns
                    .map(
                        (x) =>
                            `${
                                x.width +
                                (x.columnPosition === 1 ? QUEUE_ROW_UPDATE_BOX_WIDTH_PX : 0)
                            }px`
                    )
                    .join(' '),
            }}
        >
            <Grid
                templateColumns="var(--columns)"
                position="sticky"
                top="0px"
                zIndex="5"
                minHeight="22"
            >
                {/* Separate component for column rendering so that we do not re-render each header during reordering or resizing because of new react elements for the headers  */}
                <QueueColumnHeaders
                    workspaceQueue={store.workspacePanel.queue}
                    onReorder={handleReorder}
                    onResize={handleResize}
                    onSort={handleSort}
                />
            </Grid>
            {children}
        </Box>
    );
});
